var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"w-12 h-10 mx-1",class:_vm.classes,attrs:{"disabled":_vm.disabled,"focusable":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"flex justify-center items-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }